<template v-if="globaljs.acc_type !== 'hospital'">
	<form ref="form_aiorder_status_list" id="form_aiorder_status_list"
		:action="`${SERVER_URL}/api/app/aiorder/lab_status_count`" @submit.prevent="form_aiorder_status_list_submit()"
		method="post" autocomplete="off">
		<div class="box2_date">
			<div class="arrow arrow_pre"></div>
			<input type="month" id="Ostatus_date" ref="dateInput" v-model="date" pattern="[0-9]{4}-[0-9]{2}"
				@change="getModels()">
			<div class="arrow arrow_next"></div>
		</div>

		<table>
			<thead>
				<tr>
					<th class="osCols1">날짜</th>
					<th class="osCols2">주문</th>
					<th class="osCols3">출고임박</th>
					<th class="osCols4">출고 완료</th>
					<th class="osCols5">리메이크</th>
				</tr>
			</thead>
			<tbody id="order_table">
				<tr v-if="items.length > 0" v-for="(item, index) in items" :key="index"
					:class="{ 'active': item.today }">
					<td class="osCols1"><span class="mnone">{{ item.date.slice(0, 5) }}</span>{{ item.date.slice(5) }}
					</td>
					<td class="osCols2">{{ item.today_order }}</td>
					<td class="osCols3">{{ item.out_soon }}</td>
					<td class="osCols4">{{ item.today_out_complete }}</td>
					<td class="osCols5">{{ item.today_remake }}</td>
				</tr>
				<tr v-else>
					<td colspan="5">데이터가 없습니다.</td>
				</tr>
			</tbody>
		</table>
	</form>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as aiorderjs from '@/components/utils/aiorder';

if(globaljs.acc_type === 'hospital') { commonjs.authSwal(); }

const date = ref(moment().format('YYYY-MM'));

const items = ref([]);

onMounted(async () => {
	if(globaljs.acc_type !== 'hospital') {
		aiorderjs.DOMLoaded();

		const dateInputElement = document.getElementById("Ostatus_date");
		if (dateInputElement) {
			dateInputElement.addEventListener("dateChanged", (event) => {
				date.value = event.detail;
				getModels();
			});
		}

		await getModels();
	}
});

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('lab_mb_id', globaljs.mb_boss_id);
	params.append('date', date.value);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder/lab_status_count`, { params });
console.debug(response.data.result);
		items.value = response.data.result;

	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>